import template from './group-call-select-people.html';
import './group-call-select-people.scss';
import _ from 'lodash';

export default angular
  .module('doxy.realtime.components.groupCall.selectPeople', [])
  // group-call-select-people
  .component('groupCallSelectPeople', {
    template,
    bindings: {
      hide: '&',
      people: '<',
    },
    controller: function (
      communicationControl,
      VideoProviderFactory,
      notificationFactory,
      pn,
      $translate,
      groupCallService
    ) {
      const MAX_PEOPLE_ON_CALL_COUNT = groupCallService.getMaxPatientsCount();

      const peopleOnCurrentCallCount =
        VideoProviderFactory.activeProvider.peopleCollection.length;
      this.peopleToSelect = MAX_PEOPLE_ON_CALL_COUNT - peopleOnCurrentCallCount;
      this.selected = [];
      this.people = [];

      const inCallPeople =
        VideoProviderFactory.activeProvider.peopleCollection.models;
      const isAvailable = (person) => {
        if (!person.isPatient()) {
          return false;
        }
        if (person.state.status === 'video') {
          return false;
        }
        return !inCallPeople.some(
          (inCallPerson) => inCallPerson.uuid === person.uuid
        );
      };

      const setPeople = () => {
        this.people = pn.people.filter(isAvailable);
      };

      const leaveHandler = (person) => {
        setPeople();
        _.remove(this.selected, person);
      };

      const activate = () => {
        setPeople();
        pn.on('join', setPeople);
        pn.on('leave', leaveHandler);
      };

      this.$onInit = () => {
        pn.connected ? activate() : pn.once('connected', activate);
      };

      this.$onDestroy = () => {
        pn.off('join', setPeople);
        pn.off('leave', leaveHandler);
      };

      this.isSelected = (person) => {
        return Boolean(this.selected.includes(person));
      };

      this.canAddCount = () => {
        return (
          MAX_PEOPLE_ON_CALL_COUNT -
          peopleOnCurrentCallCount -
          this.selected.length
        );
      };

      this.toggleSelect = (person) => {
        if (person.isOnMobileApp()) {
          return notificationFactory.showCommon(
            'info',
            `iOS app users can't be added to group call`,
            null,
            5000
          );
        }
        if (this.selected.includes(person)) {
          this.selected.splice(this.selected.indexOf(person), 1);
        } else {
          if (
            this.selected.length + peopleOnCurrentCallCount ===
            MAX_PEOPLE_ON_CALL_COUNT
          ) {
            return;
          }
          this.selected.push(person);
        }
      };

      this.chat = (person) => {
        communicationControl.openChat(person);
      };

      this.invite = async () => {
        if (this.selected.length === 0) {
          return;
        }
        const selected = this.selected.splice(0, this.selected.length);
        await communicationControl.addToGroupCall(selected);
        this.hide();
        this.selected = [];
      };

      this.getTitle = (person) => {
        if (person.isOnMobileApp()) {
          return `iOS app users can't be added to group call`;
        }
        return this.isSelected(person) ? 'Deselect' : 'Add to selection';
      };

      const TITLE_SIGN_MAP = {
        waitingRoomEmpty: $translate.instant(
          'account.groupCall.waitingRoomEmpty'
        ),
        maxReachDescription: $translate.instant(
          'account.groupCall.maxReachDescription'
        ),
        description: $translate.instant('account.groupCall.description'),
      };

      const getTitleSign = _.memoize(
        (canAddCount, canInviteCount) => {
          const hasPeopleToSelect = canInviteCount > 0;
          switch (true) {
            case !hasPeopleToSelect:
              return {
                html: TITLE_SIGN_MAP.waitingRoomEmpty,
                class: 'custom-modal-header__sign--empty',
              };
            case canAddCount === 0:
              return { html: TITLE_SIGN_MAP.maxReachDescription, class: '' };
            case canAddCount === 1:
              return { html: TITLE_SIGN_MAP.description, class: '' };
            case canAddCount > 1:
              return {
                html: $translate.instant(
                  'account.groupCall.description-plural{count}',
                  {
                    count: canAddCount,
                  }
                ),
                class: '',
              };
          }
        },
        (...args) => JSON.stringify(args)
      );

      this.getTitleSign = () => {
        const canAddCount = this.canAddCount();
        const canInviteCount = this.people.length;

        return getTitleSign(canAddCount, canInviteCount);
      };
    },
  }).name;
